export const MyLeadsText = "My Leads";
export const LeadsAreAvailableText = "Leads are available until marked Sold, Declined, Lost, Unresponsive, or Locked";
export const SearchLeadsAriaLabel = "Search Leads";
export const SearchLeadsPlaceholder = "Search by Name";
export const DateFilterLabel = "Date";
export const Last7DaysText = "Last 7 days";
export const Last30DaysText = "Last 30 days";
export const Last365DaysText = "Last 365 days";

export const NoLeadsText = "We Can't Find Any Leads That Match";
export const NoLeadsSubText = "To find the lead you're looking for, try:";
export const NoLeadsBullet1 = "Checking your spelling";
export const NoLeadsBullet2 = "Changing your search criteria";
export const NoLeadsBullet3 = "Selecting different filters";
export const NoLeadsBullet4 = "Contacting support if you need help";

export const NoLeadsYet = "No leads here... yet!";
export const NoLeadsYetSubText = "Once a lead is assigned to your store it will appear here.";
export const NoUnassignedLeadsText = "All leads have been assigned!";
export const NoUnassignedLeadsSubText = "There's nothing else to do here until new leads arrive.";
